import { faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FileRejection } from 'react-dropzone/.';
import { Trans } from 'react-i18next';
import { S_Alert } from '../../../../design/alert/S_Alert';
import { S_Dropzone } from '../../../../design/dropzone/S_Dropzone';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';

export interface IUnlockModalProps {
  showUnlockModal: boolean;
  wrongKeyFile: boolean;
  workspaceName?: string;
  onFilesDrop: (files: File[]) => Promise<void>;
  onWrongFilesDrop: (fileRejections: FileRejection[]) => void;
  onCancel: () => void;
}

export const UnlockWorkspaceModal = observer((props: IUnlockModalProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={props.showUnlockModal}
      toggle={props.onCancel}
      headerText={t('key_upload')}
      buttons={
        <Button
          color='neutral'
          variant='outlined'
          onClick={props.onCancel}
        >
          {t('cancel')}
        </Button>
      }
    >
      <div>
        <Trans
          i18nKey={'key_upload_description'}
          values={{ workspace: props.workspaceName }}
          components={{ b: <b /> }}
        />
      </div>
      {props.wrongKeyFile && <S_Alert color='warning'>{t('key_error')}</S_Alert>}
      <S_Dropzone
        onDropAccepted={(files) => {
          void props.onFilesDrop(files);
        }}
        onDropRejected={props.onWrongFilesDrop}
        accept={{ 'application/pkcs8': ['.key'] }}
      >
        <FontAwesomeIcon icon={faKey} />
        {t('key_dropzone')}
      </S_Dropzone>
    </S_Modal>
  );
});
